import * as React from 'react';

import styles from './tab-container.module.css';

type Props = {
    getRef?: (arg1?: HTMLElement | null | undefined) => void;
    children?: React.ReactNode;
};

// Note - this needs to be React.Component, because React Router
// internally will check on re-render if the tab is active,
// but the props will not change.
export class TabContainer extends React.Component<Props> {
    render() {
        return (
            <div ref={this.props.getRef} className={styles['tab-container']}>
                {this.props.children}
            </div>
        );
    }
}
